export const COLORS = {
    PRIMARY: '#37576D',
    FILL: '#FFFFFF',
    TEXT: '#37576D',
    SECONDARY: '#74A4BC',
    DISABLED: 'rgba(163,154,146,0.3)',
    WHITE: '#FFFFFF',
    BLACK: '#000000',
    TRANSPARENT: 'transparent',
    GRID: 'rgba(0,0,0,0.15)',
    SECONDARY_SHAPE_STROKE: '#162D3D',
    DEFAULT_BACKGROUND: '#F0F4F7',
    DEFAULT_STROKE: '#37576D',
    DEFAULT_FILL: '#FFFFFF',
    DEFAULT_TEXT: '#37576D',
    BACKGROUND_WITH_NO_OPACITY_OR_COLOR: '#FFFFFF',
};
export const SEAT_CIRCLE_RADIUS = 12;
export const SEAT_CIRCLE_DIAMETER = SEAT_CIRCLE_RADIUS * 2;
export const OCCUPIED_SEAT_CIRCLE_DIAMETER = 8;
export const OCCUPIED_SEAT_FILL = 'rgba(0, 0, 0, 0.3)';
export const SEAT_SPACING = 12;
export const ROW_SPACING = 12;
export const MIN_TABLE_SIZE = SEAT_CIRCLE_DIAMETER * 4 + SEAT_SPACING * 2;
export const MIN_SHAPE_SIZE = 24;
export const MIN_LINE_LENGTH = 6;
export const MAX_STROKE_WIDTH = 6;
export const MAX_DIMENSION = 1000000;
export const SHAPE_STROKE_COLOR = COLORS.PRIMARY;
export const SHAPE_FILL_COLOR = 'white';
export const STROKE_WIDTH = 1;
export const STROKE_WIDTH_SELECTED = 2;
export const DEFAULT_TEXT = 'TEXT';
export const TEXT_FONT_SIZE = 32;
export const LABEL_FONT_SIZE = 12;
export const LABEL_LINE_HEIGHT = 1.2;
export const LABEL_FONT_FAMILY = `Madefor,'Helvetica Neue',Helvetica,Arial,'ãƒ¡ã‚¤ãƒªã‚ª','meiryo','ãƒ’ãƒ©ã‚®ãƒŽè§’ã‚´ pro w3','hiragino kaku gothic pro',sans-serif`;
export const LABEL_FONT = `normal ${LABEL_FONT_SIZE}px/${LABEL_LINE_HEIGHT} ${LABEL_FONT_FAMILY}`;
export const HANDLE_TOLERANCE = 3;
export const MAX_SEATS_IN_ROW = 50;
export const MAX_ROWS_IN_MULTIROW = 50;
export const MAX_AREA_CAPACITY = 50000;
export const MAX_SEAT_LABEL_NUMERIC = 999;
export const MAX_SEAT_LABEL_LENGTH = 3;
export const MAX_TEXT_LENGTH = 40;
export const MAX_TABLE_LABEL_LENGTH = 20;
export const MAX_SECTION_NAME_LENGTH = 20;
export const MAX_SPACING_BETWEEN_SEATS = 60;
export const MAX_SHAPES = 5000;
export const MAX_SHAPES_WARNING_PERCENT = 0.9;
export const SELECTION_MANIPULATION_OPACITY = 0.5;
export const GRID_DOT_RADIUS = 1;
export const DEFAULT_OPACITY_VALUE = 1;
export const SQUARE_TABLE_DEFAULT_SEATS_PER_SIDE = 2;
export const DEFAULT_CATEGORIES_COLORS = [
    '#17B0E2',
    '#FFF500',
    '#80C979',
    '#E5C9EE',
    '#FC6500',
    '#79DDF3',
    '#C0DF00',
    '#DBCDAE',
    '#FF7B7B',
    '#FDB10C',
    '#C1E4FE',
    '#FFE5D7',
    '#FFA3A1',
    '#3D9FA1',
    '#B7FF8B',
    '#EF73C0',
    '#68A4D5',
    '#FEF4CD',
];
//# sourceMappingURL=constants.js.map